import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(({ typography }) => ({
  headingContainer: (props: any) => ({
    display: 'flex',
    flexDirection: 'row',
    marginTop: props.hideIcon ? '0px' : '4px',
  }),
  alertContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  root: (props: any) => ({
    display: 'flex',
    padding: '15px',
    borderRadius: '5px',
    overflowWrap: 'anywhere',
    justifyContent: 'start',
    alignContent: 'center',
    marginBottom: '18px',
    justifyContent: props.hideIcon ? 'space-between' : 'unset',
    '&.error': {
      backgroundColor: 'rgba(253,237,237)',
      '& .text': {
        color: 'rgba(95, 33, 32)',
        fontSize: '13px',
        alignSelf: 'center',
        fontWeight: typography.fontWeightSemiBold,
      },
      '& .subText': {
        color: 'rgba(34, 34, 34)',
        fontSize: '14px',
        alignSelf: 'center',
        fontWeight: typography.fontWeightRegular,
        opacity: '70%',
      },
      '& .icon': {
        color: 'rgba(95, 33, 32)',
        marginRight: '8px',
      },
    },
    '&.warning': {
      backgroundColor: 'rgba(255,244,229)',
      '& .text': {
        color: 'rgba(102, 60, 0)',
        fontSize: '13px',
        alignSelf: 'center',
        fontWeight: typography.fontWeightSemiBold,
      },
      '& .subText': {
        color: 'rgba(102, 60, 0)',
        fontSize: '13px',
        alignSelf: 'center',
        fontWeight: typography.fontWeightRegular,
        opacity: '70%',
      },
      '& .icon': {
        color: '#CF752F',
        height: '16px',
        width: '16px',
        marginRight: '8px',
      },
    },
    '&.info': {
      backgroundColor: '#E9F5FE',
      '& .text': {
        color: '#3E8CC1',
        fontSize: '13px',
        alignSelf: 'center',
        fontWeight: 400,
      },
      '& .subText': {
        color: 'rgba(34, 34, 34)',
        fontSize: '14px',
        alignSelf: 'center',
        fontWeight: typography.fontWeightRegular,
        opacity: '70%',
      },
      '& .icon': {
        color: '#3E8CC1',
        marginRight: '8px',
        height: '16px',
        width: '16px',
      },
    },
    '&.success': {
      backgroundColor: 'rgba(237, 247, 237)',
      '& .text': {
        color: 'rgba(30, 70, 32)',
        fontSize: '13px',
        alignSelf: 'center',
        fontWeight: typography.fontWeightSemiBold,
      },
      '& .subText': {
        color: 'rgba(34, 34, 34)',
        fontSize: '14px',
        alignSelf: 'center',
        fontWeight: typography.fontWeightRegular,
        opacity: '70%',
      },
      '& .icon': {
        color: 'rgba(76, 175, 80)',
        marginRight: '12px',
      },
    },
  }),
  closeButton: (props: any) => ({
    height: '16px',
    borderRadius: 0,
    color: props.hideIcon ? '#00B8A3' : '#3B82F6',
    marginLeft: '12px',
    alignSelf: 'center',
    padding: '0',
  }),
}), { name: 'Alert' });

export default useStyles;
